import { FormattedMessage } from "react-intl";
import { Category } from "~/api/model";
import { Button } from "~/components/ui/button";
import { Modal } from "~/components/ui/modal";

interface ViewCategoryDialogProps {
  category: Category;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onEdit?: () => void;
}

export function ViewCategoryDialog({
  category,
  open,
  onOpenChange,
  onEdit,
}: ViewCategoryDialogProps) {
  const handleEdit = () => {
    onOpenChange(false);
    onEdit?.();
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={
        <div className="flex items-center gap-2 text-lg truncate">
          <div
            className="h-4 w-4 rounded-full border-none"
            style={{ backgroundColor: category.color }}
          />
          {category.name}
        </div>
      }
      description={
        <p className="text-muted-foreground text-sm">{category.definition}</p>
      }
      content={
        <div className="grid gap-4">
          {category.length && (
            <div className="space-y-2">
              <h3 className="font-medium">
                <FormattedMessage id="viewCategory.length" />
              </h3>
              <p className="text-sm text-muted-foreground">{category.length}</p>
            </div>
          )}

          {category.keyTopics && (
            <div className="space-y-2">
              <h3 className="font-medium">
                <FormattedMessage id="viewCategory.keyTopics" />
              </h3>
              <p className="text-sm text-muted-foreground whitespace-pre-line">
                {category.keyTopics}
              </p>
            </div>
          )}

          {category.expectedContent && (
            <div className="space-y-2">
              <h3 className="font-medium">
                <FormattedMessage id="viewCategory.expectedContent" />
              </h3>
              <p className="text-sm text-muted-foreground whitespace-pre-line">
                {category.expectedContent}
              </p>
            </div>
          )}

          {category.recognitionTips && (
            <div className="space-y-2">
              <h3 className="font-medium">
                <FormattedMessage id="viewCategory.recognitionTips" />
              </h3>
              <p className="text-sm text-muted-foreground whitespace-pre-line">
                {category.recognitionTips}
              </p>
            </div>
          )}

          {category.namingConvention && (
            <div className="space-y-3">
              <h3 className="font-medium">
                <FormattedMessage id="categoryListItem.namingConventions" />
              </h3>
              <p className="text-sm text-muted-foreground whitespace-pre-line">
                {category.namingConvention}
              </p>
            </div>
          )}

          {category.namingExample && (
            <div className="space-y-3">
              <h3 className="font-medium">
                <FormattedMessage id="categoryListItem.namingExamples" />
              </h3>
              <p className="text-sm text-muted-foreground whitespace-pre-line">
                {category.namingExample}
              </p>
            </div>
          )}
        </div>
      }
      footer={
        <>
          <Button
            type="button"
            variant="outline"
            onClick={handleEdit}
            className="sm:mr-auto"
          >
            <FormattedMessage id="edit" />
          </Button>
          <Button type="button" onClick={handleClose}>
            <FormattedMessage id="close" />
          </Button>
        </>
      }
    />
  );
}
